import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Setup() {
  const navigate = useNavigate();
  const { login, loadOrg } = useAuth();
  const [checking, setChecking] = useState(true);
  const [form, setForm] = useState({ name: "", email: "mehmetakman03@gmail.com", password: "", password2: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/auth/setup-status").then(({ data }) => {
      if (!data.needs_setup) navigate("/giris");
      else setChecking(false);
    }).catch(() => setChecking(false));
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.password2) { setError("Parolalar eşleşmiyor."); return; }
    if (form.password.length < 6) { setError("Parola en az 6 karakter olmalı."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/setup", { name: form.name, email: form.email, password: form.password });
      login(data.token, data.user);
      await loadOrg();
      toast.success("Kurulum tamamlandı. Hoş geldiniz.");
      navigate("/");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  if (checking) return <div className="min-h-screen flex items-center justify-center bg-slate-900"><Loader2 className="h-8 w-8 animate-spin text-sky-400" /></div>;

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-slate-200 shadow-2xl">
        <CardHeader className="text-center space-y-3">
          <div className="mx-auto h-12 w-12 rounded-xl bg-sky-600 flex items-center justify-center">
            <ShieldCheck className="h-7 w-7 text-white" />
          </div>
          <CardTitle className="font-display text-2xl">İlk Kurulum</CardTitle>
          <p className="text-sm text-slate-500">Ana yönetici (uygulama sahibi) hesabını oluşturun. Bu adım yalnızca bir kez yapılır.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label>Ad Soyad</Label>
              <Input data-testid="setup-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Adınız Soyadınız" required />
            </div>
            <div className="space-y-1.5">
              <Label>E-posta</Label>
              <Input data-testid="setup-email-input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div className="space-y-1.5">
              <Label>Parola</Label>
              <Input data-testid="setup-password-input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
            </div>
            <div className="space-y-1.5">
              <Label>Parola (Tekrar)</Label>
              <Input data-testid="setup-password2-input" type="password" value={form.password2} onChange={(e) => setForm({ ...form, password2: e.target.value })} required />
            </div>
            {error && <p className="text-sm text-rose-600" data-testid="setup-error">{error}</p>}
            <Button type="submit" className="w-full bg-sky-600 hover:bg-sky-700" disabled={loading} data-testid="setup-submit-button">
              {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Kurulumu Tamamla
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
